// extracted by mini-css-extract-plugin
export default {"container":"pZ-z","heading":"qZ-z","links":"rZ-z","copy":"sZ-z","subCopy":"tZ-z","linksLeft":"uZ-z","linksCenter":"vZ-z","linksRight":"wZ-z","link":"xZ-z","onlyLink":"yZ-z"};